/**
 * Copyright ©2022 Drivepoint
 */

import {LicenseInfo} from "@mui/x-license-pro";

export default class Licenses {

  static init(): void {
    LicenseInfo.setLicenseKey(
      "2cd41279b4d55c0d820ea2c4b900e1a9Tz0xMTcyNTMsRT0xNzg1OTc0Mzk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y"
    );
  }

}